// Components
import Vimeo from "./Vimeo";

const VimeoContainer = (props) => {
    return <Vimeo {...props} />;
};

export default VimeoContainer;
